<template>
  <div v-if="showColors || showUnits" :class="b(mods)">
    <div v-if="showColors" :class="b('item')">
      <ga-product-card-colors
        :options="colorsOptions"
        :size="size"
        :count="colorsCount"
      />
    </div>
    <div v-if="showUnits && showColors" :class="b('divider')" />
    <div v-if="showUnits" :class="b('item')">
      <ga-product-card-units
        :options="unitsOptions"
        :size="size"
        :force-compact="showColors"
      />
    </div>
  </div>
</template>

<script src="./attributes.scripts.js" />

<style module src="./attributes.styles.scss" lang="scss" />
